import { Component, Input, OnInit } from '@angular/core';
import { CartService } from 'src/app/shared/cart.service';

@Component({
  selector: 'app-out-of-stock-popover',
  templateUrl: './out-of-stock-popover.component.html',
  standalone: false
})
export class OutOfStockPopoverComponent implements OnInit {

  @Input() group;

  constructor(
    public cartService: CartService
  ) { }

  ngOnInit() { }

}
